import { useEffect } from 'react';

/**
 * Attaches an IntersectionObserver to all .reveal* elements
 * so they animate in when scrolled into view.
 * Re-runs on every route change (call inside each page component or App).
 */
function useReveal(deps = []) {
  useEffect(() => {
    // Small timeout lets the new page DOM render first
    const id = setTimeout(() => {
      const els = document.querySelectorAll(
        '.reveal, .reveal-left, .reveal-right, .reveal-scale'
      );
      const observer = new IntersectionObserver(
        (entries) =>
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add('visible');
              observer.unobserve(e.target); // fire once only
            }
          }),
        { threshold: 0.1 }
      );
      els.forEach((el) => observer.observe(el));
      return () => observer.disconnect();
    }, 80);
    return () => clearTimeout(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export default useReveal;
